<template>
  <div>
    <template v-if="!loading">
      <b-row align-v="center">
        <b-col lg="4">
          <b-row align-v="center">
            <b-col cols="8" lg="12">
              <h6 class="h6-semibold-azure-uppercase">{{ current.pad(2) }}</h6>
              <h3 class="h3-semibold-black">Energie alternative</h3>
            </b-col>

            <b-col cols="4" lg="12" v-if="isMobile" class="mb-4">
              <div class="icon">
                <img src="img/icone/SGR-Icons-Energia-alternativa.svg">
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="4">

          <b-form-group
              label="Hai un impianto Solare termico?"
              label-for="field1"
              :state="states.impianto_solare_termico"
          >
            <b-form-select id="field1" v-model="localOptions.energie_alternative.impianto_solare_termico"
                           :options="siNo"
                           @input="setValid($event,'impianto_solare_termico')"
                           class="form-control form-control-gray-900"></b-form-select>
          </b-form-group>

          <b-form-group
              label="Hai un impianto Solare fotovoltaico?"
              label-for="field2"
              :state="states.impianto_solare_fotovoltaico"
          >
            <b-form-select id="field2" v-model="localOptions.energie_alternative.impianto_solare_fotovoltaico"
                           :options="siNo"
                           @input="setValid($event,'impianto_solare_fotovoltaico')"
                           class="form-control form-control-gray-900"></b-form-select>
          </b-form-group>

          <b-form-group
              label="Qual’è la potenza nominale del tuo impianto?"
              label-for="field3"
              :state="states.potenza_nominale"
              v-if="localOptions.energie_alternative.impianto_solare_fotovoltaico"
          >
            <div class="input-group mb-2">
              <div class="input-group-prepend">
                <div class="input-group-text">kW</div>
              </div>
              <b-form-input id="field3" v-model="localOptions.energie_alternative.potenza_nominale"
                            @input="setValid($event,'potenza_nominale')"
                            placeholder="Es: 3" type="number"
                            class="form-control form-control-gray-900"></b-form-input>
            </div>
          </b-form-group>

        </b-col>
        <b-col lg="3" offset-lg="1" class=" text-center lg:text-right">
          <div class="icon" v-if="!isMobile">
            <img src="img/icone/SGR-Icons-Energia-alternativa.svg">
          </div>
          <button @click="nextStep" class="button-azure-rounded mt-2 lg:mt-8 px-8">Avanti</button>
        </b-col>
      </b-row>
    </template>
  </div>

</template>

<script>
export default {
  name: 'Step-5',
  data() {
    return {
      thisStep: 5,
      localOptions: null,
      siNo: [{text: 'Seleziona un valore', value: ''}, {text: 'Sì', value: true}, {text: 'No', value: false}],
      loading: true,
      states: {},
    }
  },
  props: {
    steps: {
      type: Number,
      required: true,
    },
    current: {
      type: Number,
      default: 1,
    },
    options: {
      type: [Array, Object],
      required: true
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  created() {
    if (this.options.step < this.thisStep) this.$router.push({name: 'step-1'})
    this.$emit('setCurrent', this.thisStep)
    this.localOptions = {...this.options};
    this.loading = false;

    if(typeof this.$analytics != 'undefined') {
      this.trackFbViewContent('check-up-energetico', 'step-5');
    }
  },
  methods: {
    nextStep() {
      let that = this;
      let valid = true;
      let hasFotovoltaico = that.localOptions.energie_alternative.impianto_solare_fotovoltaico
      that.states = {};
      for (const [key, value] of Object.entries(that.localOptions.energie_alternative)) {
        if ((key != 'potenza_nominale' || (key == 'potenza_nominale' && hasFotovoltaico)) && (value === null || value === '')) {
          that.states[key] = true;
          valid = false;
        }
      }
      if (valid) this.$emit('nextStep', this.thisStep + 1, this.localOptions);
    },
    setValid(value, key) {
      this.states[key] = value === null || value === '';
    }
  },
}
</script>

<style scoped lang="scss">
</style>